import IframeActivity from "./IframeActivity";

export default function TakingAdvice() {
    return (
        <IframeActivity
            src="/activities/taking-advice/index.html"
            title="Taking Advice"
        />
    );
}